<div
  [formGroup]="formGroup"
  class="d-flex align-items-center justify-content-start"
  [ngClass]="{ 'flex-column-reverse': labelOnTop }"
>
  <input
    type="checkbox"
    [id]="controlName"
    [formControlName]="controlName"
    class="form-control-input mr-1"
    style="transform: scale(1.2)"
  />
  <label
    [for]="controlName"
    class="form-control-label"
    [ngClass]="{ 'ml-1': !labelOnTop }"
    style="margin-bottom: 0"
    [class.text-danger]="isInvalid"
    >{{ label }}</label
  >
</div>
